(function () {
  var $ = window.jQuery;

  function findParent (parentDependency) {
    return document.querySelector(`[data-dependency="${parentDependency}"]`);
  }

  function withDependentValues (baseUrl, values) {
    const params = new URLSearchParams();
    values.forEach(value => params.append('dependent_value[]', value));
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}${params.toString()}`;
  }

  function parentReader (parentEl) {
    const isSelect = parentEl.tagName === 'SELECT';
    const container = isSelect ? null : parentEl.closest('.easy-autocomplete-tag');

    function valueEl () {
      return isSelect ? parentEl : (container && container.querySelector('input[type="hidden"]'));
    }

    // A <select> is authoritative at once; an autocomplete only after its widget creates the hidden value input.
    function ready () {
      return isSelect || !!valueEl();
    }

    function values () {
      if (isSelect) {
        return Array.from(parentEl.selectedOptions).map(option => option.value).filter(value => value !== '');
      }
      const hidden = valueEl();
      return hidden && hidden.value ? [hidden.value] : [];
    }

    function onChange (callback) {
      if (isSelect) {
        parentEl.addEventListener('change', callback);
      } else if ($ && container) {
        // the widget creates its hidden value input after this binds, so delegate from the container
        $(container).on('change', 'input[type="hidden"]', callback);
      }
    }

    return { ready, values, onChange };
  }

  class DependentCustomEntitySelect {
    constructor (tagId, value, parentDependency, url) {
      this.values = String(value == null ? '' : value).split(',').filter(Boolean);
      this.url = url;
      this.$select = document.getElementById(tagId);
      const parentEl = findParent(parentDependency);
      if (!parentEl || !this.$select) return;

      this.parent = parentReader(parentEl);
      this.parent.onChange(() => this.reload(true));
      this.reload(false);
    }

    clearOptions () {
      const keepBlank = this.$select.options.length > 0 && this.$select.options[0].value === '';
      this.$select.options.length = keepBlank ? 1 : 0;
    }

    reload (parentChanged) {
      if (!parentChanged && !this.parent.ready()) return;

      const values = this.parent.values();

      if (values.length === 0) {
        this.clearOptions();
        this.$select.disabled = true;
        if (parentChanged) this.values = [];
        this.dispatchChange(parentChanged);
        return;
      }

      this.$select.disabled = false;
      if (!parentChanged) return; // initial options are already server-rendered and scoped
      fetch(withDependentValues(this.url, values), {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(response => response.json())
        .then(data => {
          const entities = (data && data.entities) || [];
          this.values = this.values.filter(value => entities.some(entity => String(entity.id) === value));
          // repopulate only after a successful fetch, so a transient error leaves the current options intact
          this.clearOptions();
          entities.forEach(entity => {
            const selected = this.values.includes(String(entity.id));
            this.$select.add(new Option(entity.value, entity.id, false, selected));
          });
          this.dispatchChange(parentChanged);
        })
        .catch(() => {});
    }

    dispatchChange (parentChanged) {
      // re-entrancy guard: a misconfigured parent/child cycle would otherwise recurse until the stack blows
      if (!parentChanged || this.dispatching) return;

      this.dispatching = true;
      try {
        this.$select.dispatchEvent(new Event('change'));
      } finally {
        this.dispatching = false;
      }
    }
  }

  class DependentCustomEntityAutocomplete {
    constructor (tagId, parentDependency, baseUrl) {
      this.baseUrl = baseUrl;
      this.input = document.getElementById(tagId);
      const parentEl = findParent(parentDependency);
      if (!parentEl || !this.input) return;

      this.parent = parentReader(parentEl);
      this.parent.onChange(() => this.apply(true));
      this.apply(false);
    }

    apply (parentChanged) {
      if (!parentChanged && !this.parent.ready()) return;
      if (parentChanged) this.reset();

      const values = this.parent.values();
      this.input.disabled = values.length === 0;
      if (values.length && $) {
        try {
          $(this.input).easymultiselect('option', 'source', withDependentValues(this.baseUrl, values));
        } catch (e) { /* widget not initialised yet: the server-rendered source is already scoped */ }
      }
    }

    reset () {
      this.input.value = '';
      if (!$) return;
      const hidden = $(this.input).closest('.easy-autocomplete-tag').find('input[type="hidden"]');
      if (hidden.length) {
        hidden.val('');
        hidden.trigger('change');
      }
    }
  }

  window.EASY = window.EASY || {};
  window.EASY.customFields = window.EASY.customFields || {};
  window.EASY.customFields.DependentCustomEntitySelect = DependentCustomEntitySelect;
  window.EASY.customFields.DependentCustomEntityAutocomplete = DependentCustomEntityAutocomplete;
})();
